const POPUP_TO_BALLOON_GAP = 4;

export function getBalloonSideIndent(newbuildingId?: number, featureId?: string | number): number | undefined {
  if (!newbuildingId) {
    return;
  }

  const isNewbuildingMainPin = typeof featureId === 'string' && featureId.startsWith('main_nb_pin_');
  const mainPinSelector = isNewbuildingMainPin ? '[data-newbuilding-main-pin]' : ':not([data-newbuilding-main-pin])';
  const balloon = document.querySelector<HTMLElement>(`[data-newbuilding="${newbuildingId}"]${mainPinSelector}`);
  const balloonWidth = balloon?.getBoundingClientRect().width;

  return balloonWidth ? Math.ceil(balloonWidth / 2) + POPUP_TO_BALLOON_GAP : undefined;
}
